export default __webpack_public_path__ + "static/media/64.2814a491.jpg";